"use strict";

require("@polkadot/types-codec/types/registry");